import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeQuotationLostReasonCreate,
  detail: routeQuotationLostReasonDetail,
  home: routeQuotationLostReasonHome,
  root: routeQuotationLostReasonRoot,
} = createDoctypeRoutes({
  createName: 'new-quotation-lost-reason',
  createPath: 'new-quotation-lost-reason',
  detailName: 'quotation-lost-reason-detail',
  doctype: DOCTYPES.QUOTATION_LOST_REASON,
  homeName: 'quotation-lost-reason',
  path: 'quotation-lost-reason',
  views: {
    create: async () =>
      await import(
        '@/components/viewsExternal/settings/sales/quotationLostReason/AddQuotationLostReason.vue'
      ),
    detail: async () =>
      await import(
        '@/components/viewsExternal/settings/sales/quotationLostReason/ViewQuotationLostReason.vue'
      ),
    list: async () =>
      await import('@/components/viewsExternal/settings/sales/ViewSalesSettings.vue'),
  },
})

export {
  routeQuotationLostReasonCreate,
  routeQuotationLostReasonDetail,
  routeQuotationLostReasonHome,
  routeQuotationLostReasonRoot,
}
